export const phoneNumbers = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    region: 'Asia',
  },
  {
    name: 'Aland Islands',
    dial_code: '+358',
    code: 'AX',
    region: 'Europe',
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL',
    region: 'Europe',
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
    region: 'Africa',
  },
  {
    name: 'American Samoa',
    dial_code: '+1684',
    code: 'AS',
    region: 'Oceania',
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD',
    region: 'Europe',
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO',
    region: 'Africa',
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    code: 'AI',
    region: 'North America',
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    code: 'AQ',
    region: 'Antarctica',
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG',
    region: 'North America',
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR',
    region: 'South America',
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM',
    region: 'Asia',
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: 'AW',
    region: 'North America',
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU',
    region: 'Oceania',
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT',
    region: 'Europe',
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
    region: 'Asia',
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    code: 'BS',
    region: 'North America',
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
    region: 'Asia',
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
    region: 'Asia',
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    code: 'BB',
    region: 'North America',
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY',
    region: 'Europe',
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE',
    region: 'Europe',
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ',
    region: 'North America',
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ',
    region: 'Africa',
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    code: 'BM',
    region: 'North America',
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
    region: 'Asia',
  },
  {
    name: 'Bolivia',
    dial_code: '+591',
    code: 'BO',
    region: 'South America',
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
    region: 'Europe',
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW',
    region: 'Africa',
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR',
    region: 'South America',
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO',
    region: 'Asia',
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
    region: 'Asia',
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
    region: 'Europe',
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
    region: 'Africa',
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI',
    region: 'Africa',
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
    region: 'Asia',
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
    region: 'Africa',
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA',
    region: 'North America',
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: 'CV',
    region: 'Africa',
  },
  {
    name: 'Cayman Islands',
    dial_code: '+1345',
    code: 'KY',
    region: 'North America',
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
    region: 'Africa',
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: 'TD',
    region: 'Africa',
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL',
    region: 'South America',
  },
  {
    name: 'China',
    dial_code: '+86',
    code: 'CN',
    region: 'Asia',
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
    region: 'Oceania',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC',
    region: 'Oceania',
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO',
    region: 'South America',
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM',
    region: 'Africa',
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG',
    region: 'Africa',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    code: 'CD',
    region: 'Africa',
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
    region: 'Oceania',
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
    region: 'North America',
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI',
    region: 'Africa',
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR',
    region: 'Europe',
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU',
    region: 'North America',
  },
  {
    name: 'Curaçao',
    dial_code: '+599',
    code: 'CW',
    region: 'North America',
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
    region: 'Asia',
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ',
    region: 'Europe',
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK',
    region: 'Europe',
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
    region: 'Africa',
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    code: 'DM',
    region: 'North America',
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    code: 'DO',
    region: 'North America',
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
    region: 'South America',
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG',
    region: 'Africa',
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
    region: 'North America',
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
    region: 'Africa',
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
    region: 'Africa',
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE',
    region: 'Europe',
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
    region: 'Africa',
  },
  {
    name: 'Falkland Islands',
    dial_code: '+500',
    code: 'FK',
    region: 'South America',
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
    region: 'Europe',
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
    region: 'Oceania',
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI',
    region: 'Europe',
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR',
    region: 'Europe',
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
    region: 'South America',
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
    region: 'Oceania',
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA',
    region: 'Africa',
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM',
    region: 'Africa',
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE',
    region: 'Asia',
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE',
    region: 'Europe',
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: 'GH',
    region: 'Africa',
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
    region: 'Europe',
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: 'GR',
    region: 'Europe',
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL',
    region: 'North America',
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    code: 'GD',
    region: 'North America',
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
    region: 'North America',
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    code: 'GU',
    region: 'Oceania',
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
    region: 'North America',
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    code: 'GG',
    region: 'Europe',
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN',
    region: 'Africa',
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
    region: 'Africa',
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    code: 'GY',
    region: 'South America',
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT',
    region: 'North America',
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN',
    region: 'North America',
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
    region: 'Asia',
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU',
    region: 'Europe',
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS',
    region: 'Europe',
  },
  {
    name: 'India',
    dial_code: '+91',
    code: 'IN',
    region: 'Asia',
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
    region: 'Asia',
  },
  {
    name: 'Iran',
    dial_code: '+98',
    code: 'IR',
    region: 'Asia',
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: 'IQ',
    region: 'Asia',
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
    region: 'Europe',
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: 'IM',
    region: 'Europe',
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: 'IL',
    region: 'Asia',
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT',
    region: 'Europe',
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    code: 'JM',
    region: 'North America',
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: 'JP',
    region: 'Asia',
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: 'JE',
    region: 'Europe',
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO',
    region: 'Asia',
  },
  {
    name: 'Kazakhstan',
    dial_code: '+7',
    code: 'KZ',
    region: 'Asia',
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: 'KE',
    region: 'Africa',
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
    region: 'Oceania',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: 'KP',
    region: 'Asia',
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: 'KR',
    region: 'Asia',
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
    region: 'Asia',
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
    region: 'Asia',
  },
  {
    name: 'Laos',
    dial_code: '+856',
    code: 'LA',
    region: 'Asia',
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV',
    region: 'Europe',
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
    region: 'Asia',
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
    region: 'Africa',
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR',
    region: 'Africa',
  },
  {
    name: 'Libya',
    dial_code: '+218',
    code: 'LY',
    region: 'Africa',
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
    region: 'Europe',
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
    region: 'Europe',
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
    region: 'Europe',
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: 'MO',
    region: 'Asia',
  },
  {
    name: 'Macedonia',
    dial_code: '+389',
    code: 'MK',
    region: 'Europe',
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
    region: 'Africa',
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW',
    region: 'Africa',
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
    region: 'Asia',
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV',
    region: 'Asia',
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: 'ML',
    region: 'Africa',
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT',
    region: 'Europe',
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
    region: 'Oceania',
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
    region: 'North America',
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
    region: 'Africa',
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
    region: 'Africa',
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
    region: 'Africa',
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX',
    region: 'North America',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: 'FM',
    region: 'Oceania',
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    code: 'MD',
    region: 'Europe',
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC',
    region: 'Europe',
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
    region: 'Asia',
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
    region: 'Europe',
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: 'MS',
    region: 'North America',
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA',
    region: 'Africa',
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
    region: 'Africa',
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
    region: 'Asia',
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA',
    region: 'Africa',
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR',
    region: 'Oceania',
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP',
    region: 'Asia',
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
    region: 'Europe',
  },

  {
    name: 'Sint Maarten',
    dial_code: '+1721',
    code: 'SX',
    region: 'North America',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    dial_code: '+599',
    code: 'BQ',
    region: 'North America',
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
    region: 'Oceania',
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
    region: 'Oceania',
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
    region: 'North America',
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: 'NE',
    region: 'Africa',
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
    region: 'Africa',
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU',
    region: 'Oceania',
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
    region: 'Oceania',
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    code: 'MP',
    region: 'Oceania',
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: 'NO',
    region: 'Europe',
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM',
    region: 'Asia',
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
    region: 'Asia',
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW',
    region: 'Oceania',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS',
    region: 'Asia',
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA',
    region: 'North America',
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
    region: 'Oceania',
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
    region: 'South America',
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE',
    region: 'South America',
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH',
    region: 'Asia',
  },
  {
    name: 'Pitcairn',
    dial_code: '+872',
    code: 'PN',
    region: 'Oceania',
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: 'PL',
    region: 'Europe',
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT',
    region: 'Europe',
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    code: 'PR',
    region: 'North America',
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA',
    region: 'Asia',
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO',
    region: 'Europe',
  },
  {
    name: 'Russia',
    dial_code: '+7',
    code: 'RU',
    region: 'Europe',
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
    region: 'Africa',
  },
  {
    name: 'Reunion',
    dial_code: '+262',
    code: 'RE',
    region: 'Africa',
  },
  {
    name: 'Saint Barthelemy',
    dial_code: '+590',
    code: 'BL',
    region: 'North America',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH',
    region: 'Africa',
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    code: 'KN',
    region: 'North America',
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    code: 'LC',
    region: 'North America',
  },
  {
    name: 'Saint Martin',
    dial_code: '+590',
    code: 'MF',
    region: 'North America',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM',
    region: 'North America',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    code: 'VC',
    region: 'North America',
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS',
    region: 'Oceania',
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM',
    region: 'Europe',
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
    region: 'Africa',
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
    region: 'Asia',
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN',
    region: 'Africa',
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS',
    region: 'Europe',
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
    region: 'Africa',
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
    region: 'Africa',
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG',
    region: 'Asia',
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
    region: 'Europe',
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
    region: 'Europe',
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
    region: 'Oceania',
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO',
    region: 'Africa',
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
    region: 'Africa',
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: 'SS',
    region: 'Africa',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS',
    region: 'South America',
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: 'ES',
    region: 'Europe',
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
    region: 'Asia',
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: 'SD',
    region: 'Africa',
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR',
    region: 'South America',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
    region: 'Europe',
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    code: 'SZ',
    region: 'Africa',
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE',
    region: 'Europe',
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
    region: 'Europe',
  },
  {
    name: 'Syria',
    dial_code: '+963',
    code: 'SY',
    region: 'Asia',
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: 'TW',
    region: 'Asia',
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
    region: 'Asia',
  },
  {
    name: 'Tanzania',
    dial_code: '+255',
    code: 'TZ',
    region: 'Africa',
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH',
    region: 'Asia',
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
    region: 'Asia',
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG',
    region: 'Africa',
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
    region: 'Oceania',
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO',
    region: 'Oceania',
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    code: 'TT',
    region: 'North America',
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
    region: 'Africa',
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: 'TR',
    region: 'Asia',
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
    region: 'Asia',
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    code: 'TC',
    region: 'North America',
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
    region: 'Oceania',
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG',
    region: 'Africa',
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
    region: 'Europe',
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
    region: 'Asia',
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
    region: 'Europe',
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US',
    region: 'North America',
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
    region: 'South America',
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
    region: 'Asia',
  },
  {
    name: 'Vatican City',
    dial_code: '+379',
    code: 'VA',
    region: 'Europe',
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
    region: 'Oceania',
  },
  {
    name: 'Venezuela',
    dial_code: '+58',
    code: 'VE',
    region: 'South America',
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: 'VN',
    region: 'Asia',
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    code: 'VG',
    region: 'North America',
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    code: 'VI',
    region: 'North America',
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
    region: 'Oceania',
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE',
    region: 'Asia',
  },
  {
    name: 'Kosovo',
    dial_code: '+383',
    code: 'XK',
    region: 'Europe',
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
    region: 'Africa',
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
    region: 'Africa',
  },
]
